import Page from 'modules/Cart'

export default Page

